import {entity} from "../../../components/ListComponentEntity";
import {NavLink} from "react-router-dom";
import React from "react";
import {NewList} from "../../../components/NewList/NewList";

export const ListProviderReturnNew = (props) => {
    return (
        <NewList
            { ...props } stockNav additionalFieldsExists isFilterExists
            entity={'stock/provider-return'}
            entity_type={32}
            requiredFields={'id,name,stock_id,date'}
            requiredExpand={'stock'}
            deleteToShowColumn={'id,name,stock_id,date'}
            filterFields={entity.stockReturn.fArr}
            singleSearch={entity.stockReturn.fArr[0]}
            headingColumns={['Номер', 'Статус', 'Дата']}
            RenderColumn={(item) => (
                <>
                    <td>
                        <NavLink to={`/stock/return/${item.id}`}  className={'nowrap-list-column'}>{item.name}</NavLink>
                    </td>
                    <td>
                        {item.stock && <span className="label-st" style={{ backgroundColor: 'rgb(255, 193, 100)' }}>{item.stock.name}</span>}
                    </td>
                    <td>
                        <div>{item.date}</div>
                    </td>
                </>
            )}
            createButtonRender={(setModalType) => <button onClick={() => setModalType('return')} className="open-modal-button btni">Новый возврат</button>}
            rightNavbarConfig={{
                additionalFields: '/fieldsettings/32',
                columns: true
            }}
            massDoConfig={{ deleteAll: `/ajax/stock/return/delete-all` }}
            contextNav={{ edit: true, task: true, print: true, delete: true }}
            sort={entity.stockReturn.fArr.filter(el => el.sort)}
        />
    )
}